import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  editContactDetails,
  fetchAssociatedInvestment,
  fetchContactDetailsEdit,
  fetchReferenceContacts,
} from '../Slice/FundActions';

export const getContactDetails = createAsyncThunk(
  'contact/getDetails',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchContactDetailsEdit(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const UpdateContactDetails = createAsyncThunk(
  'contact/updateDetails',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await editContactDetails(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getAssociatedInvestments = createAsyncThunk(
  'contact/getAssociatedInvestment',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchAssociatedInvestment(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getReferenceContacts = createAsyncThunk(
  'contact/getReferenceContacts',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchReferenceContacts(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
